import { ArrowUp, ArrowUpLeft, ArrowUpRight, CornerUpLeft, CornerUpRight, Flag, RotateCcw, Undo2 } from "lucide-react";
import type { Route, RouteStep } from "./lib/types";
import { formatDistance, formatDuration } from "./lib/navigation";

export function maneuverKind(step?: RouteStep) {
  if (step?.type === "arrive") return "arrive";
  if (step?.type === "depart") return "straight";
  if (step?.type.includes("roundabout") || step?.type.includes("rotary")) return "roundabout";
  return step?.modifier || "straight";
}
export function ManeuverIcon({ step, size = 28 }: { step?: RouteStep; size?: number }) {
  const kind = maneuverKind(step);
  const Icon = kind === "arrive" ? Flag : kind === "roundabout" ? RotateCcw : kind === "uturn" ? Undo2 :
    kind === "slight left" ? ArrowUpLeft : kind === "slight right" ? ArrowUpRight :
    kind.includes("left") ? CornerUpLeft : kind.includes("right") ? CornerUpRight : ArrowUp;
  return <Icon size={size} aria-hidden="true" />;
}

export function RouteOverview({ route, currentIndex, destination }: { route: Route; currentIndex?: number; destination: string }) {
  return <section className="route-overview">
    <h2>{destination}</h2>
    <p>{formatDuration(route.duration)} · {formatDistance(route.distance)} · {route.steps.length} הוראות בדרך</p>
    <ol aria-label="כל הפניות במסלול">
      {route.steps.map((step, index) => <li key={index} aria-current={index === currentIndex ? "step" : undefined}
        className={currentIndex !== undefined && index < currentIndex ? "step-passed" : ""}>
        <span className="maneuver-symbol"><ManeuverIcon step={step} /></span>
        <div>{index === currentIndex && <small className="step-current">ההנחיה הבאה</small>}
          <strong>{step.instruction || (step.type === "arrive" ? "הגעה ליעד" : "המשך ישר")}</strong>
          {step.name && <span>{step.name}</span>}
          {step.type !== "arrive" && <small>מקטע של {formatDistance(step.distance)}</small>}
        </div>
      </li>)}
    </ol>
  </section>;
}
